<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="邮箱" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="mainSelect.email" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>

              <el-col :lg="5" :xl="5">
                <el-form-item label="邮箱类型" class="EL-Form-Item">
                  <el-select v-model="mainSelect.emailType" placeholder="请选择" filterable clearable="clearable">
                    <el-option  label="来料环节" value="01"></el-option>
                    <el-option  label="领料环节" value="02"> </el-option>
                    <el-option  label="退库环节" value="03"> </el-option>
                    <el-option  label="仓库库存" value="04"> </el-option>
                    <el-option  label="质检破坏" value="05"> </el-option>
                    <el-option  label="XA订单" value="06"> </el-option>
                    <el-option  label="保质期到期提醒" value="07"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>

                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="邮箱列表">
                <el-button v-authority="'BACK_MENU8_M5_B1'" class="btn-t-edit" @click="(add_or_edit = true), (editBoxShow = true)">新增</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total">
                <!-- <el-table-column prop="authId" label="序号" /> -->
                <el-table-column prop="email" label="邮箱" />
                <el-table-column label="邮箱类型" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.emailType=='01'">来料环节</div>
                    <div v-if="scope.row.emailType=='02'">领料环节</div>
                    <div v-if="scope.row.emailType=='03'">退库环节</div>
                    <div v-if="scope.row.emailType=='04'">仓库库存</div>
                    <div v-if="scope.row.emailType=='05'">质检破坏</div>
                    <div v-if="scope.row.emailType=='06'">XA订单</div>
                    <div v-if="scope.row.emailType=='07'">保质期到期提醒</div>
                  </template>
                </el-table-column>
                <el-table-column label="状态" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.status">正常</div>
                    <div v-if="!scope.row.status">停用</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU8_M5_B3'" size="mini" type="primary" @click="
                (add_or_edit = false),
                  (editBoxShow = true),
                  (mainObj = JSON.parse(JSON.stringify(scope.row)))
              " plain icon="el-icon-edit-outline" />
                        <el-button v-authority="'BACK_MENU8_M5_B2'" type="danger" @click="deleteRow(scope.row.emailId)" size="mini" plain icon="el-icon-delete" />
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 新增&&编辑框 -->
        <el-dialog :title="add_or_edit ? '新增' : '编辑'" :close-on-click-modal="false" :visible.sync="editBoxShow" width="700px" :model="mainObj" @open="open">
            <span class="formClass">
                <el-form :inline="true" label-position="top" label-width="80px" :model="mainObj" :rules="rules" ref="mainObj">
                    <!-- <cascadeSearch ref="cascadeSearch" :f.sync="mainObj.fcCode" :w.sync="mainObj.shopCode" @change="queryMainData(),mainObj.sectionCode = ''" /> -->
                    <el-form-item label="邮箱" prop="email">
                        <el-input v-model="mainObj.email"> </el-input>
                    </el-form-item>
                    <el-form-item label="邮箱类型" prop="emailType">
                       <el-select v-model="mainObj.emailType" placeholder="请选择" filterable>
                        <el-option  label="来料环节" value="01"></el-option>
                        <el-option  label="领料环节" value="02"> </el-option>
                        <el-option  label="退库环节" value="03"> </el-option>
                         <el-option  label="仓库库存" value="04"> </el-option>
                         <el-option  label="质检破坏" value="05"> </el-option>
                        <el-option  label="XA订单" value="06"> </el-option>
                         <el-option  label="保质期到期提醒" value="07"> </el-option>
                      </el-select>
                    </el-form-item>
                   <el-form-item label="状态" prop="status">
                       <el-select v-model="mainObj.status" placeholder="请选择" >
                        <el-option  label="正常" :value="true"></el-option>
                        <el-option  label="停用" :value="false"> </el-option>
                      </el-select>
                    </el-form-item>

                </el-form>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" type="info" @click="close()">
                    取 消
                </el-button>
                <el-button size="small" type="primary" v-if="add_or_edit" @click="add">
                    新 增
                </el-button>
                <el-button size="small" type="primary" v-else @click="editRow">
                    修 改
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>

    export default {
        name: "AuxiMaterial",
        data() {
            return {
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                form: {},
                rules: {
                    emailType: [{
                        required: true,
                        message: "请选择",
                        trigger: "blur",
                    }, ],
                    email: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    status: [{
                      required: true,
                      message: "请选择",
                      trigger: "blur",
                    }, ],

                    // note: [{
                    // required: true,
                    // message: '请输入',
                    // trigger: 'blur'
                    // }],
                },
                mainSelect:{
                  status:"",
                  emailType:"",
                  email:"",

                },
                mainLine: {
                    authId: null,
                    authName: "",
                    authCode: "",
                    authView: "",
                    authSystem: "",
                    parentId: "",
                    note: "",
                    createTime: "",
                    updateTime: "",
                },
                mainObj: {},
                add_or_edit: Boolean, //新增|编辑
                loading: 0, //加载中
                editBoxShow: false, //编辑框
                EditDialogVisible: false,
                formLabelWidth: "270px",
                tableHeight: 0, //表格高度
                // 分页
                pagination: {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                },
                // 页面展示主信息
                mainData: [],

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            pagination: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getAuxiMaterialData(newVal);
                    },1000)
                },
                deep: true,
            },
        },
        methods: {
            close() {
                this.editBoxShow = false;
                this.mainObj = {}
            },
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.getAuxiMaterialData()
                }, 1000)
            },
            //获取数据
            getAuxiMaterialData() {
                this.$http
                    .request({
                        url: "/api/emailConfig/getEmailData",
                        method: "GET",
                        params: {
                            pageNum: this.pagination.pageNum,
                            pageSize: this.pagination.pageSize,
                            email: this.mainSelect.email,
                            emailType: this.mainSelect.emailType,
                            status: this.mainSelect.status,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mainData = resp.data.list || [];
                            this.pagination.total = resp.data.total;
                        }
                    })
                    .catch((error) => {});
            },

            //表单验证
            submitForm(formName) {
                let r = Boolean;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        r = true;
                    } else {
                        r = false;
                    }
                });
                return r;
            },
            //框打开
            open() {
                if (this.add_or_edit) {
                    //新增
                    this.mainObj = JSON.parse(
                        JSON.stringify({
                            emailId: null,
                            emailType: "",
                            email: "",

                        })
                    );
                } else {
                    this.getAuxiMaterialData();
                }
            },
            //新增
            add() {
                if (this.submitForm("mainObj")) {
                    this.$http
                        .request({
                            url: "/api/emailConfig/addEmail",
                            method: "POST",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "新增成功！",
                                    type: "success",
                                });
                                this.logRemarks = "email：邮箱新增成功"+JSON.stringify(this.mainObj);
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "email：邮箱新增失败";
                            }
                            this.logContent = "addEmail：" + this.mainObj.emailId;
                            this.systemLog();
                            this.editBoxShow = false;
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //编辑
            editRow() {
                if (this.submitForm("mainObj")) {
                    this.$http
                        .request({
                            url: "/api/emailConfig/updateEmail",
                            method: "PUT",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "修改成功！",
                                    type: "success",
                                });
                                this.logRemarks = "email：邮箱修改成功"+JSON.stringify(this.mainObj);
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "updateEmail：邮箱修改失败";
                            }
                            this.logContent = "authCode：" + this.mainObj;
                            this.systemLog();
                            this.editBoxShow = false;
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //删除
            deleteRow(authId) {
                this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                        confirmButtonText: "删除",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/emailConfig/deleteEmail",
                                method: "DELETE",
                                showLoading: true,
                                params: {
                                    emailId: authId,
                                    // data: this.nowDateTime()
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$notify({
                                        title: "成功",
                                        message: "删除成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "email：删除成功"+JSON.stringify(this.mainObj);
                                } else {
                                    this.$notify.error({
                                        title: "失败",
                                        message: resp.message,
                                    });
                                    this.logRemarks = "email：删除成功";
                                }
                                this.logContent = "emailId：" + authId;
                                this.systemLog();
                                this.getAuxiMaterialData();
                            })
                            .catch((error) => {
                                this.$notify.error({
                                    title: "失败",
                                    message: "调用失败",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            },

            //重置
            resetData() {
                this.pagination = {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    authCode: "",
                    authName: "",
                    authSystem: "",
                };
                this.getAuxiMaterialData();
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "权限管理",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            /* 获取首页的数据 */
            this.getAuxiMaterialData();
        },
    };
</script>

<style scoped>
</style>